import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import {  AlertService } from '../_services';
import { WhatsnewService } from '../_services';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';

declare var jquery: any;
declare var $: any;
declare var alertify: any;



@Component({
  selector: 'app-whatsnew',
  templateUrl: './whatsnew.component.html',
  styleUrls: ['./whatsnew.component.css']
})
export class WhatsnewComponent implements OnInit, OnDestroy, AfterViewInit {
  whatsnewForm: FormGroup;
  loading = false;
  imageExist = '';
  fileToUpload: File = null;
  ids:any;
  submitted = false;
  //table = false;
  cancelButton = false;
  users$: Observable<any[]>;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  width_limit1 = `${environment.whatsnewWidth1}`;
  height_limit1 = `${environment.whatsnewHeight1}`;
  width_limit2 = `${environment.whatsnewWidth2}`;
  height_limit2 = `${environment.whatsnewHeight2}`;
  media_domain = `${environment.media_domain}`;
  curPage = 1;
  perPage = 10;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    // private bannersService: BannersService,
    private whatsnewService: WhatsnewService,
    private alertService: AlertService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    const urlRegex = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/
    this.whatsnewForm = this.formBuilder.group({
      index: [{ value: null, disabled: true }],
      _id: [{ value: null, disabled: true }],
      name: ['', [Validators.required, Validators.maxLength(500)]],
      link: ['', [Validators.pattern(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)]],
      large_image: '',
      // status: ''
    });


    this.dtOptions = {
      pagingType: 'full_numbers',
      processing: true,
      pageLength: 10,
      language: {
        searchPlaceholder: "Name"
      },
      columnDefs: [{
        searchable: false,
        orderable: false,
        targets: 0
      }]
      //order: [[ 1, 'asc' ]]
    };

    this.whatsnewService.getWhatsnew().subscribe(data => {
      console.log(data);
      this.users$ = data.data.whatsnew;
      this.dtTrigger.next();
    }, error => {
      console.error(error);
    });

  }



  handleFileInput(event: any, files: FileList) {
    var that = this;
    var reader = new FileReader();

    reader.onload = function (e) {
      var img = new Image;
      img.onload = function () {
        var imgWidth1 = parseInt(that.width_limit1)
        var imgHeight1 = parseInt(that.height_limit1)
        var imgWidth2 = parseInt(that.width_limit2)
        var imgHeight2 = parseInt(that.height_limit2)
        if ((img.width != imgWidth1 || img.height != imgHeight1) &&  (img.width != imgWidth2 || img.height != imgHeight2)){
          that.toastr.error('Please upload image of ' + imgWidth1 + '*' + imgHeight1 + 'or' + imgWidth2 + '*' + imgHeight2)
          that.whatsnewForm.get('large_image').setValue('');

          return false;
        } else {
          that.fileToUpload = files.item(0);

        }
      };
      img.src = reader.result as string;
    };

    reader.readAsDataURL(files.item(0));

  }
  // convenience getter for easy access to form fields
  get f() { return this.whatsnewForm.controls; }

  onSubmit(form, formWrap) {
    this.submitted = true;
    let id = form.getRawValue()._id;
    let index = form.getRawValue().index;

    if (id == null || !this.imageExist) {
      this.whatsnewForm.get('large_image').setValidators([Validators.required]);
      this.whatsnewForm.get('large_image').updateValueAndValidity();
    }
    // stop here if form is invalid
    if (this.whatsnewForm.invalid) {
      return;
    }
var that=this;
    if (that.ids != null) {
      console.log(that.ids);
      document.body.classList.add('jw-modal-open');
      that.loading = true;
      console.log(that.whatsnewForm)
      that.whatsnewService.update(that.ids, that.f.name.value, that.f.link.value, that.fileToUpload)
        .subscribe(
          data => {
            if (data.status.code == 0) {
              location.reload();
              that.submitted = false;
              document.body.classList.remove('jw-modal-open');
              that.loading = false;
              that.cancelButton = false;
              // document.getElementsByClassName("tb-wrapper")[0].classList.remove('disabledTable');
              // this.users$[index] = data.data.banner;
              that.whatsnewForm.setValue({
                index: null,
                _id: null,
                name: '',
                status: '',
                large_image: ''
              })
              formWrap.reset();
              that.imageExist = '';

              that.fileToUpload = null;

              //this.router.navigate(['/banners']);

            } else {
              document.body.classList.remove('jw-modal-open');
              that.loading = false;
              that.toastr.error(data.status.message)
              // alertify.error(data.status.message)
              //this.alertService.error(data.status.message);
            }
          },
          error => {
            this.toastr.error(error);
            // alertify.error(error)
            //this.alertService.error(error);
            document.body.classList.remove('jw-modal-open');
            that.loading = false;
          });
    } else {
      document.body.classList.add('jw-modal-open');
      this.loading = true;
      this.whatsnewService.save(this.f.name.value, this.f.link.value, this.fileToUpload)
        .subscribe(
          data => {
            if (data.status.code == 0) {
              this.toastr.success('successfully added');
              location.reload();
              this.users$ = data.data.main;
              this.whatsnewService.getWhatsnew().subscribe(data => {
                console.log(data);
                this.users$ = data.data.banner;
                this.dtTrigger.next();
              }, error => {
                console.error(error);
              });

              this.submitted = false;
              document.body.classList.remove('jw-modal-open');
              this.loading = false;
              this.cancelButton = false;
              location.reload();

              //this.users$.unshift(data.data.banner)

              this.whatsnewForm.setValue({
                index: null,
                _id: null,
                name: '',
                status: '',
                large_image: ''
              })
              formWrap.reset();
              this.fileToUpload = null;

              //this.router.navigate(['/banners']);
              location.href = "/banners";

            } else {
              document.body.classList.remove('jw-modal-open');
              this.loading = false;
              this.toastr.error(data.status.message)
              // alertify.error(data.status.message)
              //this.alertService.error(data.status.message);
            }
          },
          error => {
            this.toastr.error(error)
            // alertify.error(error)
            //this.alertService.error(error);
            document.body.classList.remove('jw-modal-open');
            this.loading = false;
          });
    }
    //this.bannerForm.reset() // reset form to empty


  }

  imageEdit(event) {
    this.imageExist = '';
  }
  userEdit(event, user, i) {
    console.log(user);
    this.ids = user._id;
    this.cancelButton = true;
    //this.table = event.currentTarget.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement;
    document.getElementsByClassName("tb-wrapper")[0].classList.add('disabledTable');
    this.whatsnewForm.patchValue({
      index: i,
      _id: user._id,
      name: user.title,
      link: user.url_link,
      status: parseInt(user.active),
      large_image: ''

    })
    this.imageExist = user.image;
  }

  cancelSubmit(event) {
    this.imageExist = '';
    this.cancelButton = false;
    document.getElementsByClassName("tb-wrapper")[0].classList.remove('disabledTable');
    this.whatsnewForm.setValue({
      index: null,
      _id: null,
      name: '',
      link: '',
      status: '',
      large_image: ''
    })
    this.submitted = false;
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if ($.fn.dataTable.isDataTable('#table')) {
        var table = $('#table').DataTable();
      }
    }, 500);
  }


}
